import { AxiosResponse } from "axios";
import { Printer } from "../types/printer";
import { aplClient } from "./apiClient";
import { OfflinePrintersSearchProps } from "../types/offlinePrintersSearchProps";

const getPrintersOffline = async (props: OfflinePrintersSearchProps): Promise<AxiosResponse<Printer[], any>> =>
    aplClient().get("Printers", { params: props });

const getPrintersOfflineBySiteId = async (siteId: number): Promise<AxiosResponse<Printer[], any>> =>
    aplClient().get("Printers", {
        params: {
            siteId: siteId,
            departmentId: 0,
            lineId: 0,
            groupByPrinterId: true,
            offline: true
        }
    });

export { getPrintersOffline, getPrintersOfflineBySiteId };
